import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

import bg from '../img/bg-testimonial.jpg';

const FooterWrapper = styled.footer`
  position: relative;
  background: ${props => 'url(' + bg + ')'} #E7F8FC bottom center no-repeat;
  background-size: cover;
  width: 100%;
  padding: 140px 5% 60px 5%;
  box-sizing:border-box;
  color: #9B9B9B;
  ul, li {
    display: inline-block;
    vertical-align: middle;
    text-align: center;
  }
  .language {
    width: 100%;
  }
  .options {
    li {
      padding: 20px 0;
      &:before {
        content: '•';
        font-size: 10px;
        vertical-align: middle;
        padding: 0 6px;
      }
      &:first-child {
        &:before {
          display: none;
        }
      }
    }
  }
  a {
    color: #9B9B9B;
  }
  @media (min-width: ${breakpoints.desktop}) {
    display: flex;
    justify-content: space-between;
    padding: 120px 5% 60px 5%;
    .language {
      flex: initial;
      width: auto;
      li {
        text-align: center;
      }
    }
    ul, li {
      text-align: left;
    }
    .left {
      flex: 1 1 auto;
    }
    .options {
      li {
        padding: 0;
      }
    }
  }
`;

export default FooterWrapper;



// WEBPACK FOOTER //
// ./src/styled-components/FooterWrapper.js